export const PRODUCT_REQUEST='PRODUCT_REQUEST';
export const PRODUCT_FAILURE='PRODUCT-FAILURE';
export const GET_PRODUCT_SUCCESS='GET_PRODUCT_SUCCESS';
export const POST_PRODUCT_SUCCESS='POST_PRODUCT_SUCCESS';
export const REMOVE_PRODUCT_SUCCESS='REMOVE_PRODUCT_SUCCESS';
export const PATCH_PRODUCT_SUCCESS='PATCH_PRODUCT_SUCCESS';
